import Button from "@builder/components/general/Button";
import { setLeftInstance, openLeftSidebar } from "@builder/store/slices/sidebarSlice";
import { useAppDispatch } from "@builder/store/store";
import "./style.scss";

const AddElemPlus = () => {
    const dispatch = useAppDispatch();

    const handleClick = () => {
        dispatch(setLeftInstance("addElement"));
        dispatch(openLeftSidebar());

    };

    return (
        <div  id="builder-add-elem-plus" className="add-elem-button-wrapper" onClick={handleClick}>
            <Button buttonStyle="secondary" className="add-elem-button" onClick={handleClick} icon={{src: "/plus-icon-white.svg"}} />
        </div>
    );
};

export default AddElemPlus;
